import React, { useEffect, useMemo, useState } from "react";
import Navbar from "../Navbar/Navbar";
import { insertReportIssue, getCustomerList, getReportList, closeReport, getClosedReportList } from "../../Redux/Config/Action";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { format, startOfYear } from "date-fns";
import { getProjectMaster, gettaskpriority, gettaskstatus, gettasktype, getWorklogData } from "../../Redux/Task/Action";
import './ReportIssue.css'
import { useLocation, useNavigate } from "react-router-dom";
import NewDataTable from "../DataTable/NewDataTable";
import DatePicker from "react-datepicker";
import Icon from "../utility/Icon";
import { FaEdit } from "react-icons/fa";
import Select from 'react-select';
import { FaInfoCircle } from "react-icons/fa";
import { FaList } from "react-icons/fa6";
import { IoCloseSharp } from "react-icons/io5";



const ClosedIssueList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role");
    const loginId = localStorage.getItem("loginId");
    const location = useLocation();
    const rowData = location.state?.rowData;
    const { customerlist, closedIssueList } = useSelector((store) => store.config);
    const { getprojectDropdownData, taskType, taskPriority, taskStatus, taskWorklogdata } = useSelector((store) => store.task);

    const [onEditing, setonEditing] = useState(false);
    const [activeTab, setActiveTab] = useState("All");
    const [fromDate, setFromDate] = useState(startOfYear(new Date()));
    const [toDate, setToDate] = useState(new Date());
    const [status, setStatus] = useState("All");
    const [show, setShow] = useState(false);
    const [reportData, setreportData] = useState(null);
    const [showInfo, setShowInfo] = useState(false);
    const [showWorklogModal, setshowWorklogModal] = useState(false);
    const [assignTo, setAssignTo] = useState("");
    const [issueNo, setIssueNo] = useState("");
    const [issueTitle, setIssueTitle] = useState("");
    const [closeModal, setCloseModal] = useState(false);


    const initialValues = {
        reportIssueId: "",
        projectCode: "",
        customerName: "",
        issueType: "",
        issueDate: new Date(),
        issueDesc: "",
        actionType: "INSERT",
        reportIssuer: loginId,
        hrmsTaskMasterId: "",
        module: "",
        title: "",
        priorityCode: "",
    }

    const [report, setReport] = useState(initialValues);

    const closeReportinitialValues = {
        reportIssueId: "",
        patchUpdateDate: "",
        remarks: "",
    };

    const [closeReportData, setCloseReportData] = useState(closeReportinitialValues);


    useEffect(() => {
        const id = role === "ROLE_ADMIN" ? "ALL" : loginId;
        dispatch(getClosedReportList(format(fromDate, "yyyy-MM-dd"), format(toDate, "yyyy-MM-dd"), id, token));
        dispatch(getCustomerList(token));
        dispatch(getProjectMaster(token));
        dispatch(gettasktype(token));
        dispatch(gettaskpriority(token));
        dispatch(gettaskstatus(token));

    }, [dispatch, token, loginId, fromDate, toDate]);

    const handleAdd = () => {
        setReport(initialValues);
        setShow(true);
        setonEditing(false);
    }
    const handleClose = () => {
        setReport(initialValues);
        setShow(false);
        setonEditing(false);

    }

    const handleEdit = (rowData) => {
        if (rowData) {
            const priority = taskPriority.find(p => p.priorityName === rowData.priorityCode);
            const type = taskType.find(p => p.ticketType === rowData.issueType);
            setonEditing(true);
            setReport((prev) => ({
                ...prev,
                reportIssueId: rowData?.reportIssueId,
                projectCode: rowData?.projectCode,
                customerName: rowData?.customerName,
                issueType: type?.ticketTypeId || "",
                issueDesc: rowData?.issueDesc,
                actionType: "UPDATE",
                reportIssuer: rowData?.reportIssuer,
                hrmsTaskMasterId: rowData?.hrmsTaskMasterId,
                module: rowData?.module,
                title: rowData?.title,
                priorityCode: priority?.priorityCode || "",
            }));
        }
        setShow(true);
    }



    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!report.projectCode || !report.customerName || !report.priorityCode || !report.issueType) {
            Swal.fire({
                icon: "warning",
                title: "Warning",
                text: "Please fill all the required fields.",
                timer: 2000,
            });
            return;
        }

        const result = await Swal.fire({
            title: "Are you sure?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, submit it!",
            cancelButtonText: "No, cancel",
        });
        if (result.isConfirmed) {
            dispatch(insertReportIssue(report, token))
                .then((response) => {
                    if (response.statusCode === "00") {
                        Swal.fire({
                            title: "Success!",
                            text: response.statusDesc,
                            icon: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                        handleClose()
                        dispatch(getReportList(format(fromDate, "yyyy-MM-dd"), format(toDate, "yyyy-MM-dd"), loginId, token));
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.error,
                            icon: "error",
                            confirmButtonText: "OK",
                        });
                    }
                })
                .catch(() => {
                    Swal.fire({
                        title: "Error!",
                        text: "Something went wrong. Please try again later.",
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                })
        }
    };

    const handleTaskInputChange = (e) => {
        const { name, value } = e.target;
        if (value && /^[\s]/.test(value)) {
            e.preventDefault();
            return;
        }
        else {
            setReport({ ...report, [name]: value });
        }
    };

    const Tooltip = ({ text, children }) => {
        return (
            <div className="tooltip-container">
                {children}
                <div className="tooltip">{text}</div>
            </div>
        );
    };

    const getStatusColor = (status) => {
        switch (status) {
            case "To Do":
                return "#5c43e9";   // grey
            case "In Progress":
                return "#0d6efd";   // blue
            case "In Testing":
                return "#ffc107";   // yellow
            case "Rejected":
                return "#dc3545";   // red
            case "Reopened":
                return "#fa7910";   // orange
            case "Completed":
                return "#28ca7e";   // green
            case "On Hold":
                return "#b5da72";   // green
            default:
                return "#b6b9bd";
        }
    };



    const handleInfoClick = (issueData) => {
        setreportData(issueData);
        setShowInfo(true);
    }

    const handleInfoClose = () => {
        setShowInfo(false);
        setreportData(null);
    };

    const handleView = (e) => {
        dispatch(getWorklogData(e.hrmsTaskMasterId, token, "All"));
        setAssignTo(e.assignToName);
        setshowWorklogModal(true);
        setIssueNo(e.issueNo);
        setIssueTitle(e.title);
        setreportData(e);
    };

    const closeReportClick = (row) => {
        setCloseModal(true);
        setIssueNo(row.issueNo)
        setCloseReportData((prev) => ({
            ...prev,
            reportIssueId: row.reportIssueId,
        }))
    }
    const handleReportClose = async (e) => {
        e.preventDefault();
        const result = await Swal.fire({
            title: "Are you sure?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, submit it!",
            cancelButtonText: "No, cancel",
        });
        if (result.isConfirmed) {
            dispatch(closeReport(closeReportData, token))
                .then((result) => {
                    if (result.success) {
                        dispatch(getReportList(format(fromDate, "yyyy-MM-dd"), format(toDate, "yyyy-MM-dd"), loginId, token));
                        setCloseModal(false);
                        setCloseReportData(closeReportinitialValues);
                        Swal.fire({
                            title: "Success!",
                            text: "Report closed successfully.",
                            icon: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: result.error || "Report close unsuccessfull",
                            icon: "error",
                            confirmButtonText: "OK",
                        });
                    }
                })
                .catch((err) => {
                    console.error(err);
                    Swal.fire({
                        title: "Error!",
                        text: "There was an error submitting the user details.",
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                });

        }

    }


    const columns = [
        {
            name: "Task No",
            selector: (row) => row?.issueNo || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Issue Date",
            selector: (row) => row?.issueDate || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Patch Update Date",
            selector: (row) => row?.patchUpdateDate || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Customer",
            selector: (row) => row?.customerName || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Project Name",
            selector: (row) => row?.projectCode || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Title",
            selector: (row) => row?.title || "-",
            sortable: true,
            align: "left",
        },
        {
            name: "Type",
            selector: (row) => row?.issueType || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Report Issuer",
            selector: (row) => row?.reportIssuerName || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Remarks",
            selector: (row) => row?.remarks || "-",
            sortable: true,
            align: "left",
        },
        // {
        //     name: "Status",
        //     selector: (row) => row?.status || "",
        //     sortable: true,
        //     align: "center",
        //     cell: (row) => {
        //         const status = row?.status || "Not Assigned";
        //         const bgColor = getStatusColor(status);

        //         return (
        //             <span
        //                 style={{
        //                     backgroundColor: bgColor,
        //                     color: "white",
        //                     padding: "4px 10px",
        //                     borderRadius: "12px",
        //                     fontSize: "12px",
        //                     fontWeight: 600,
        //                     display: "inline-block",
        //                     minWidth: "90px",
        //                     textAlign: "center"
        //                 }}
        //             >
        //                 {status}
        //             </span>
        //         );
        //     }
        // },

        {
            name: "Action",
            sortable: false,
            align: "center",
            cell: (row) => (
                <>
                    <Tooltip text="Info">
                        <Icon
                            icon={FaInfoCircle}
                            variant="secondary"
                            className="me-3"
                            onClick={() => handleInfoClick(row)}
                        />
                    </Tooltip>
                    <Tooltip text="View">
                        <Icon
                            icon={FaList}
                            variant="success"
                            className="me-3"
                            onClick={() => handleView(row)}
                        />
                    </Tooltip>

                </>
            ),
        }
    ];


    const filteredData = useMemo(() => {
        let data = closedIssueList;

        if (activeTab !== "All") {
            data = data.filter(
                (r) =>
                    r.issueType?.toLowerCase() === activeTab.toLowerCase()
            );
        }

        if (status === "Not Assigned") {
            data = data.filter((r) => !r.status);
        } else if (status !== "All") {
            data = data.filter(
                (r) =>
                    r.status?.toLowerCase() === status.toLowerCase()
            );
        }

        return data;
    }, [closedIssueList, activeTab, status]);



    const projectOptions = getprojectDropdownData.map(p => ({
        value: p.projectCode,
        label: p.projectName,
    }));
    const taskTypeOptions = taskType.filter(t => t.ticketType !== 'Task' && t.ticketType !== 'Story').map(p => ({
        value: p.ticketTypeId,
        label: p.ticketType,
    }));
    const taskPriorityoptions = taskPriority.map(p => ({
        value: p.priorityCode,
        label: p.priorityName,
    }));

    const customerOptions = customerlist.map(c => ({
        value: c.customerShortName,
        label: c.customerShortName,
    }));

    const taskStatusOptions = [
        { value: "All", label: "All" },
        { value: "Not Assigned", label: "Not Assigned" }, // manually adding Not Assigned option 
        ...taskStatus.map(p => ({
            value: p.description,
            label: p.description,
        }))
    ].sort((a, b) => a.label.localeCompare(b.label));


    const handleStatusChange = (selectedOption) => {
        const value = selectedOption?.value || null;
        setStatus(value);
    };


    return (
        <div>
            <Navbar />

            <div className="main-content">
                <div className="container-fluid mt-4">
                    {/* Table */}
                    <div className="card shadow-sm">
                        {/* Tabs */}
                        <div className="issue-tab-wrapper">
                            <div className="issue-tab-container">

                                {/* LEFT TABS */}
                                <div className="tabs-left">
                                    {["All", "Bug", "Issue", "Requirement"].map((tab) => {
                                        const count =
                                            tab === "All"
                                                ? closedIssueList.length
                                                : closedIssueList.filter(
                                                    (r) => r.issueType?.toLowerCase() === tab.toLowerCase()
                                                ).length;

                                        return (
                                            <div
                                                key={tab}
                                                className={`issue-tab-item ${activeTab === tab ? "active" : ""}`}
                                                onClick={() => setActiveTab(tab)}
                                            >
                                                {tab}
                                                <span className="count">{count}</span>
                                            </div>
                                        );
                                    })}
                                </div>

                                {/* RIGHT DATE SECTION */}
                                <div className="date-section">
                                    {/* <div className="date-group">
                                        <label
                                            htmlFor="status"
                                            className="form-label"
                                            id="modalLabelStatus"
                                        >
                                            Status
                                        </label>
                                        <div className="status-control">
                                            <Select
                                                options={taskStatusOptions}
                                                value={taskStatusOptions.find(opt => opt.value === status) || null}
                                                onChange={handleStatusChange}
                                            />
                                        </div>
                                    </div> */}

                                    <div className="date-group">
                                        <label>From Date</label>
                                        <DatePicker
                                            selected={fromDate}
                                            onChange={(date) => setFromDate(date)}
                                            className="form-control date-control"
                                            dateFormat="dd-MM-yyyy"
                                            showYearDropdown
                                            showMonthDropdown
                                            dropdownMode="select"
                                            onKeyDown={(event) => event.preventDefault()}
                                        />
                                    </div>

                                    <div className="date-group">
                                        <label>To Date</label>
                                        <DatePicker
                                            selected={toDate}
                                            onChange={(date) => setToDate(date)}
                                            className="form-control date-control"
                                            dateFormat="dd-MM-yyyy"
                                            showYearDropdown
                                            showMonthDropdown
                                            dropdownMode="select"
                                            minDate={fromDate}
                                            onKeyDown={(event) => event.preventDefault()}
                                        />
                                    </div>

                                </div>
                            </div>
                        </div>



                        <div className="card-body">
                            <NewDataTable
                                columns={columns}
                                data={filteredData || []}
                                tableName="CLOSED REPORT DETAILS"
                                totalRecord={filteredData?.length ?? 0}
                            />
                            {/* <div className="text-center">
                                <button className="btn btn-primary mt-3 " onClick={handleAdd}>
                                    REPORT ISSUE
                                </button>
                            </div> */}

                        </div>
                    </div>

                    {show && <div className="modal-backdrop fade show"></div>}

                    <div
                        className={`modal fade report-modal ${show ? "show d-block" : ""}`}
                        tabIndex="-1"
                        role="dialog"
                    >
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h1 className=" report-modal modal-title">{`REPORT  ${onEditing ? "UPDATE" : "ISSUE"}`}</h1>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={handleClose}
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    <div>
                                        <form onSubmit={handleSubmit}>
                                            <div className="row g-3">
                                                <div className="col-md-4">
                                                    <label
                                                        htmlFor="customerName"
                                                        className="form-label"
                                                        id="modalLabelProject"
                                                    >
                                                        Customer<span className="text-danger">*</span>
                                                    </label>
                                                    <Select
                                                        options={customerOptions}
                                                        value={customerOptions.find(opt => opt.value === report.customerName) || null}
                                                        onChange={(selectedOption) =>
                                                            setReport(prev => ({
                                                                ...prev,
                                                                customerName: selectedOption?.value || ""
                                                            }))
                                                        }
                                                        required
                                                    />
                                                </div>

                                                <div className="col-md-4">
                                                    <label
                                                        htmlFor="projectCode"
                                                        className="form-label"
                                                        id="modalLabelProject"
                                                    >
                                                        Project<span className="text-danger">*</span>
                                                    </label>
                                                    <Select
                                                        options={projectOptions}
                                                        value={projectOptions.find(opt => opt.value === report.projectCode) || null}
                                                        onChange={(selectedOption) =>
                                                            setReport(prev => ({
                                                                ...prev,
                                                                projectCode: selectedOption?.value || ""
                                                            }))
                                                        }
                                                        required
                                                    />
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="module" className="form-label">
                                                        Module<span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="module"
                                                        value={report.module || ""}
                                                        onChange={handleTaskInputChange}
                                                        className="form-control"
                                                        id="module"
                                                        required
                                                    />

                                                </div>
                                            </div>
                                            {/*---------------------------- Line 2--------------- */}
                                            <div className="row mt-2">
                                                <div className="col-md-6">
                                                    <label
                                                        htmlFor="title"
                                                        className="form-label"
                                                        id="modalLabelTaskTitle"
                                                    >
                                                        Title<span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="title"
                                                        value={report.title || ""}
                                                        onChange={handleTaskInputChange}
                                                        className="form-control"
                                                        id="title"
                                                        placeholder="Enter Title..."
                                                        required
                                                    />
                                                </div>

                                                <div className="col-md-3">
                                                    <label
                                                        htmlFor="issueType"
                                                        className="form-label"
                                                        id="modalLabelType"
                                                    >
                                                        Type<span className="text-danger">*</span>
                                                    </label>
                                                    <Select
                                                        options={taskTypeOptions}
                                                        value={taskTypeOptions.find(opt => opt.value === report.issueType) || null}
                                                        onChange={(selectedOption) =>
                                                            setReport(prev => ({
                                                                ...prev,
                                                                issueType: selectedOption?.value || ""
                                                            }))
                                                        }
                                                        required
                                                    />
                                                </div>
                                                <div className="col-md-3">
                                                    <label
                                                        htmlFor="priorityCode"
                                                        className="form-label"
                                                        id="modalLabelPriority"
                                                    >
                                                        Priority<span className="text-danger">*</span>
                                                    </label>
                                                    <Select
                                                        options={taskPriorityoptions}
                                                        value={taskPriorityoptions.find(opt => opt.value === report.priorityCode) || null}
                                                        onChange={(selectedOption) =>
                                                            setReport(prev => ({
                                                                ...prev,
                                                                priorityCode: selectedOption?.value || ""
                                                            }))
                                                        }
                                                        required
                                                    />
                                                </div>



                                            </div>

                                            <div className="row mt-2">
                                                <div className="form-group mb-3">
                                                    <label className="form-label" htmlFor="issueDesc">
                                                        Description<span className="text-danger">*</span>
                                                    </label>
                                                    <textarea
                                                        className="form-control"
                                                        name="issueDesc"
                                                        value={report.issueDesc || ""}
                                                        onChange={handleTaskInputChange}
                                                        required
                                                        id="issueDesc"
                                                    ></textarea>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col text-center mt-2">
                                                    <button type="submit" className={`btn ${onEditing ? "btn-warning" : "btn-success"}`}>
                                                        {onEditing ? "UPDATE" : "SUBMIT"}
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                </div>
                {showWorklogModal && <div className="modal-backdrop fade show"></div>}
                <div
                    className={`modal fade assign-modal ${showWorklogModal ? "show d-block" : ""}`}
                    tabIndex="-1"
                    role="dialog"
                >
                    <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header ">
                                <h5 className="modal-title mb-0">Worklogs For: {reportData?.issueNo || "-"} {issueTitle}</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setshowWorklogModal(false)}
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="modal-body pt-1">
                                <div className="worklog-wrapper mt-2">
                                    {/* PC TABLE VIEW */}
                                    <div className="d-none d-md-block">
                                        <div className="row mt-3">
                                            <div className="fw-semibold col-md-3">
                                                <span className="fw-bold">Assigned To: </span>
                                                <span className="text-primary fw-bold">{assignTo || "-"}</span>
                                            </div>
                                            <div className="fw-semibold col-md-3">
                                                <span className="fw-bold">Report Issuer: </span>
                                                <span className="text-primary fw-bold">{reportData?.reportIssuerName || "-"}</span>
                                            </div>
                                            <div className="fw-semibold col-md-3">
                                                <span className="fw-bold">Customer: </span>
                                                <span className="text-primary fw-bold">{reportData?.customerName || "-"}</span>
                                            </div>
                                            <div className="fw-semibold col-md-3">
                                                <span className="fw-bold">Project: </span>
                                                <span className="text-primary fw-bold">{reportData?.projectCode || "-"}</span>
                                            </div>
                                        </div>

                                        <div
                                            className="table-scroll-wrapper"
                                            style={{ maxHeight: "300px", overflowY: "auto" }}
                                        >
                                            <table className="table worklog-table mb-0">
                                                <thead className="sticky-top bg-white">
                                                    <tr>
                                                        <th>SN</th>
                                                        {role === "ROLE_ADMIN" && <th>Employee</th>}
                                                        <th>Date</th>
                                                        <th>Total Hour</th>
                                                        <th>Remarks</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {Array.isArray(taskWorklogdata) && taskWorklogdata.length > 0 ? (
                                                        taskWorklogdata.map((workLog, index) => (
                                                            <tr key={index}>
                                                                <td>{index + 1}</td>
                                                                {role === "ROLE_ADMIN" && <td>{workLog?.empName || "-"}</td>}
                                                                <td>{workLog?.date || "-"}</td>
                                                                <td>{workLog?.totalHour ?? "-"}</td>
                                                                <td className="text-start">{workLog?.remarks || "-"}</td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan={role === "ROLE_ADMIN" ? 5 : 4} className="text-center">
                                                                No logs available
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    {/* MOBILE CARD VIEW */}
                                    <div className="d-md-none worklog-cards">
                                        <div className="row mt-3">
                                            <div className="fw-semibold col-md-3">
                                                <span className="fw-bold">Assigned To: </span>
                                                <span className="text-primary fw-bold">{assignTo || "-"}</span>
                                            </div>
                                            <div className="fw-semibold col-md-3">
                                                <span className="fw-bold">Task No: </span>
                                                <span className="text-primary fw-bold">{reportData?.issueNo || "-"}</span>
                                            </div>
                                            <div className="fw-semibold col-md-3">
                                                <span className="fw-bold">Customer: </span>
                                                <span className="text-primary fw-bold">{reportData?.customerName || "-"}</span>
                                            </div>
                                            <div className="fw-semibold col-md-3">
                                                <span className="fw-bold">Project: </span>
                                                <span className="text-primary fw-bold">{reportData?.projectCode || "-"}</span>
                                            </div>
                                        </div>
                                        {Array.isArray(taskWorklogdata) && taskWorklogdata.length > 0 ? (
                                            taskWorklogdata.map((log, index) => (
                                                <div className="worklog-card shadow-sm" key={index}>
                                                    <div className="worklog-card-header">
                                                        <span className="worklog-sn">#{index + 1}</span>
                                                        <span className="worklog-date">{log?.date || "-"}</span>
                                                    </div>

                                                    <div className="worklog-card-body">
                                                        {role === "ROLE_ADMIN" && (
                                                            <p>
                                                                <b>Employee:</b> {log?.empName || "-"}
                                                            </p>
                                                        )}

                                                        <p>
                                                            <b>Total Hour:</b> {log?.totalHour ?? "-"}
                                                        </p>

                                                        <p className="remarks-line">
                                                            <b>Remarks:</b> {log?.remarks || "-"}
                                                        </p>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <div className="text-center mt-2">No logs available</div>
                                        )}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                {showInfo && (
                    <div
                        className="modal fade leave-modal show"
                        tabIndex="-1"
                        style={{
                            display: "block",
                            backgroundColor: "rgba(0,0,0,0.5)",
                        }}
                    >
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">{`TASK NO (${reportData.issueNo || '-'})`}</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={handleInfoClose}
                                    ></button>
                                </div>
                                <div className="modal-body text-center">
                                    <div className="row">
                                        <div className="fw-semibold col-md-4">
                                            <span className="fw-bold">Report Issuer: </span>
                                            <span className="text-primary fw-bold">{reportData?.reportIssuerName || "-"}</span>
                                        </div>
                                        <div className="fw-semibold col-md-4">
                                            <span className="fw-bold">Customer: </span>
                                            <span className="text-primary fw-bold">{reportData?.customerName || "-"}</span>
                                        </div>
                                        <div className="fw-semibold col-md-4">
                                            <span className="fw-bold">Project: </span>
                                            <span className="text-primary fw-bold">{reportData?.projectCode || "-"}</span>
                                        </div>
                                    </div><hr />
                                    {/* Points below, left-aligned, preserving line breaks */}
                                    <div className="issueDescScroll">
                                        {reportData.issueDesc || "N/A"}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                )}

                {closeModal && <div className="modal-backdrop fade show"></div>}
                <div
                    className={`modal leave-modal fade ${closeModal ? "show d-block" : ""}`}
                    tabIndex="-1"
                    role="dialog"
                >
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">CLOSE REPORT ({issueNo}) </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => {
                                        setCloseModal(false);
                                        setCloseReportData(closeReportinitialValues);
                                    }}
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="modal-body">
                                <form onSubmit={handleReportClose}>
                                    <div className="row mb-0">
                                        <div className="col-md-4">
                                            <label htmlFor="date" className="form-label">
                                                Patch Update Date <span className="text-danger">*</span>
                                            </label>

                                            <DatePicker
                                                selected={closeReportData.patchUpdateDate ? new Date(closeReportData.patchUpdateDate) : null}
                                                onChange={(date) =>
                                                    setCloseReportData({
                                                        ...closeReportData,
                                                        patchUpdateDate: date ? format(date, "yyyy-MM-dd") : "",
                                                    })
                                                }
                                                className="form-control"
                                                dateFormat="dd-MM-yyyy"
                                                placeholderText="Patch Update Date"
                                                showYearDropdown
                                                showMonthDropdown
                                                dropdownMode="select"
                                                required
                                            />
                                        </div>
                                        <div className="col-md-8">
                                            <label htmlFor="remarks" className="form-label">
                                                Remarks <span className="text-danger">*</span>
                                            </label>
                                            <textarea
                                                name="remarks"
                                                id="remarks"
                                                className="form-control"
                                                rows={3}
                                                value={closeReportData.remarks ?? ""}
                                                onChange={(e) =>
                                                    setCloseReportData({
                                                        ...closeReportData,
                                                        remarks: e.target.value,
                                                    })
                                                }
                                            />

                                        </div>

                                    </div>
                                    <div className="d-flex justify-content-center mt-5">
                                        <button
                                            className="btn btn-success"
                                            name="workLog"
                                            type="submit"
                                            style={{ minWidth: "80px" }}
                                        >
                                            SUBMIT
                                        </button>
                                    </div>
                                </form>
                                <br />

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}
export default ClosedIssueList;